export const REFERRAL_PROFILE_COOKIE_EXPIRATION_PEROID = 30; // cookie will expire in 30 days
export const USER_REFERRAL_PROFILE_COOKIE_EXPIRATION_PERIOD = 1000; // cookie will expire in 1000 days

export const REFERRAL_PROFILE_COOKIE_NAME =
  process.env.REACT_APP_REFERRAL_PROFILE_COOKIE_NAME;
